import { breakpoints, spaces } from '@99designs/common/core/settings';
import React, { ReactNode } from 'react';
import styled from 'styled-components';

const smallViewportWidth = `${breakpoints.small[0]}px`;
const mediumViewportWidth = `${breakpoints.medium[0]}px`;
const normalViewportWidth = `${breakpoints.normal[0]}px`;
const largeViewportWidth = `${breakpoints.large[0]}px`;

type Columns = {
    small: number;
    medium: number;
    normal: number;
    large: number;
};

type GridProps = {
    columns: Columns;
};

export const Grid = styled.div<GridProps>`
    display: grid;
    gap: ${spaces.gutter}px;

    @media screen and (min-width: ${smallViewportWidth}) {
        grid-template-columns: repeat(${({ columns }) => columns.small}, [col] minmax(0, 1fr));
    }

    @media screen and (min-width: ${mediumViewportWidth}) {
        grid-template-columns: repeat(${({ columns }) => columns.medium}, [col] minmax(0, 1fr));
    }

    @media screen and (min-width: ${normalViewportWidth}) {
        grid-template-columns: repeat(${({ columns }) => columns.normal}, [col] minmax(0, 1fr));
    }

    @media screen and (min-width: ${largeViewportWidth}) {
        grid-template-columns: repeat(${({ columns }) => columns.large}, [col] minmax(0, 1fr));
    }
`;

const GridItem = styled.div`
    grid-column: auto;
`;

export function Matrix({
    children,
    columnOverrides,
}: {
    children: ReactNode;
    columnOverrides?: Partial<Columns>;
}) {
    return (
        <Grid
            columns={Object.assign(
                {
                    small: 1,
                    medium: 2,
                    normal: 3,
                    large: 4,
                },
                columnOverrides
            )}
        >
            {children}
        </Grid>
    );
}

export function MatrixItem({ children }: { children: ReactNode }) {
    return <GridItem>{children}</GridItem>;
}
